// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"fd2Xa","rc-tabs-tab-active":"+H7P3","input-suffix":"VvpH4","nav-item":"_3zFpT","container":"mOFRz"};